LS.util.route({
	'price': {
		'$any': {
			':preload': 'price:preload',
			':load': 'price',
			':unload': 'price:unload'
		}
	}
});